// retrying to fetch the config multiple times,

import axios, { AxiosResponse } from 'axios';

export const getConfigFromApi = async function <T>(): Promise<T> {
  // otherwise site will not load on app start if the client builds faster than the api
  const response = await new Promise<AxiosResponse<T>>(async (resolve) => {
    let retries = 0;
    let success = false;
    const maxRetries = 5;

    const host =
      process.env.NODE_ENV === 'development'
        ? 'http://localhost:7071'
        : `${window.location.origin}/${window.location.pathname.split('/')[1]}`;

    while (!success) {
      try {
        const response = await axios.get<T>(`${host}/api/config`);
        success = true;
        resolve(response);
      } catch (err) {
        if (retries >= maxRetries) {
          throw err;
        }
        const status = err?.response?.status || 500;
        console.log(`Error getting config: ${status}. Trying again...`);

        // wait 5 seconds
        await new Promise((_) => setTimeout(_, 5000));
        retries++;
      }
    }
  });
  return response.data;
};
